














import { Component, Prop, Vue } from "vue-property-decorator"
import { Expositor } from "@/Interfaces/Programa/Expositor";
import { Material } from "@/Interfaces/Programa/Material";

@Component({})
export default class ProgramaExpositores extends Vue {
  @Prop({ required: false }) expositores: Expositor[];

}
